var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfosBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    fill: "#3A3A3A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00011 8.76908C5.87771 8.76908 5.76031 8.72045 5.67376 8.6339C5.5872 8.54734 5.53857 8.42995 5.53857 8.30754V5.07677C5.53857 4.95437 5.5872 4.83697 5.67376 4.75042C5.76031 4.66386 5.87771 4.61523 6.00011 4.61523C6.12252 4.61523 6.23991 4.66386 6.32647 4.75042C6.41302 4.83697 6.46165 4.95437 6.46165 5.07677V8.30754C6.46165 8.42995 6.41302 8.54734 6.32647 8.6339C6.23991 8.72045 6.12252 8.76908 6.00011 8.76908Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00011 4.15403C6.25501 4.15403 6.46165 3.9474 6.46165 3.6925C6.46165 3.43759 6.25501 3.23096 6.00011 3.23096C5.74521 3.23096 5.53857 3.43759 5.53857 3.6925C5.53857 3.9474 5.74521 4.15403 6.00011 4.15403Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfosBlack);
export default __webpack_public_path__ + "static/media/infos-black.b11642b2cf83867ce74bf48e45de103c.svg";
export { ForwardRef as ReactComponent };